export default __webpack_public_path__ + "archive-black-box.png";